import { useState, useCallback } from 'react';

import { Container, Label, Arrow } from './styles';

function SelectBox({ options = [], onChange = () => {} }) {
  const [value, setValue] = useState(null);

  const handleOnChange = useCallback((newValue) => {
    setValue(newValue);
    onChange(newValue);
  }, [onChange]);

  return (
    <Container>
      {options?.map(item => (
        <Label key={item.key} onClick={() => handleOnChange(item.value)} selected={value === item.value}>
          {item?.label}
          <Arrow>
            <div style={{ display: 'inline-block', border: 'solid #CB3D42', borderWidth: '0 1px 1px 0', padding: 4, transform: 'rotate(-45deg)', marginLeft: 8 }} />
          </Arrow>
        </Label>
      ))}
    </Container>
  )
}

export default SelectBox;
